import React from 'react';
import styles from './CustomSwitch.module.css';

const CustomSwitch = ({ checked, onChange }) => {
  return (
    <div className={styles.switchContainer} onClick={() => onChange(!checked)}>
      <div className={`${styles.switch} ${checked ? styles.on : styles.off}`}>
        <div className={styles.switchCircle}></div>
        <span className={styles.switchText}>{checked ? 'ON' : 'OFF'}</span>
      </div>
    </div>
  );
};

export default CustomSwitch;
